import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const WorkoutSummaryCard = ({ workout, onProvideFeedback }) => {
  const getWorkoutTypeColor = (type) => {
    switch (type) {
      case 'strength':
        return 'var(--color-primary)';
      case 'cardio':
        return 'var(--color-accent)';
      case 'flexibility':
        return 'var(--color-success)';
      default:
        return 'var(--color-muted-foreground)';
    }
  };

  const formatDate = (dateStr) => {
    const date = new Date(dateStr);
    const today = new Date();
    const yesterday = new Date(today);
    yesterday?.setDate(yesterday?.getDate() - 1);

    if (date?.toDateString() === today?.toDateString()) {
      return 'Today';
    } else if (date?.toDateString() === yesterday?.toDateString()) {
      return 'Yesterday';
    } else {
      return date?.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
    }
  };

  return (
    <div className="bg-card border border-border rounded-lg p-5 hover:shadow-md transition-shadow">
      <div className="flex items-start justify-between mb-4">
        <div className="flex-1">
          <div className="flex items-center gap-2 mb-2">
            <h3 className="text-lg font-semibold text-foreground">{workout?.name}</h3>
            {workout?.feedbackSubmitted && (
              <Icon name="CheckCircle" size={18} className="text-success" />
            )}
          </div>
          <p className="text-sm text-muted-foreground">{formatDate(workout?.date)}</p>
        </div>
        <div
          className="w-12 h-12 rounded-lg flex items-center justify-center flex-shrink-0"
          style={{ backgroundColor: `${getWorkoutTypeColor(workout?.type)}20` }}
        >
          <Icon
            name={workout?.type === 'cardio' ? 'Activity' : 'Dumbbell'}
            size={24}
            style={{ color: getWorkoutTypeColor(workout?.type) }}
          />
        </div>
      </div>

      <div className="grid grid-cols-3 gap-3 mb-4">
        <div className="bg-muted/50 rounded-lg p-3">
          <div className="flex items-center gap-2 mb-1">
            <Icon name="Clock" size={16} className="text-muted-foreground" />
            <span className="text-xs text-muted-foreground">Duration</span>
          </div>
          <p className="text-lg font-semibold text-foreground">{workout?.duration}m</p>
        </div>
        <div className="bg-muted/50 rounded-lg p-3">
          <div className="flex items-center gap-2 mb-1">
            <Icon name="Dumbbell" size={16} className="text-muted-foreground" />
            <span className="text-xs text-muted-foreground">Exercises</span>
          </div>
          <p className="text-lg font-semibold text-foreground">{workout?.exercises}</p>
        </div>
        <div className="bg-muted/50 rounded-lg p-3">
          <div className="flex items-center gap-2 mb-1">
            <Icon name="Flame" size={16} className="text-muted-foreground" />
            <span className="text-xs text-muted-foreground">Calories</span>
          </div>
          <p className="text-lg font-semibold text-foreground">{workout?.caloriesBurned}</p>
        </div>
      </div>

      {!workout?.feedbackSubmitted ? (
        <Button
          onClick={() => onProvideFeedback(workout)}
          className="w-full"
        >
          <Icon name="MessageSquare" size={18} className="mr-2" />
          Provide Feedback
        </Button>
      ) : (
        <div className="flex items-center justify-center gap-2 py-2 text-success">
          <Icon name="CheckCircle" size={18} />
          <span className="text-sm font-medium">Feedback Submitted</span>
        </div>
      )}
    </div>
  );
};

export default WorkoutSummaryCard;